import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CouponFormComponentDef } from '@df/basket/coupon-form.component.def';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { AbService } from '@df/module-ab/ab.service';
import { GtmService } from '@df/module-gtm/gtm.service';
import { TimeoutService } from '@df/ng/timeout.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { GTM_FORM_FIELD_ERROR_MESSAGE, LocalGtmService } from '../../module/gtm/gtm.service.decorator';
import { MuiInputDirective } from '../../module/legacy/forms/mui-input.directive';
import { ActionComponent } from '../../ui/api/action.component';
import { ResultComponent } from '../../ui/api/result.component';
import { ExpandableComponent } from '../../ui/display/expandable/expandable.component';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
export interface ICouponFormData {
    coupon: string | string[];
    checkout?: boolean;
}
@Component({
    selector: 'basket-view-coupon-form',
    templateUrl: './basket-view-coupon-form.html',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ResultComponent,
        TranslationModule,
        ActionComponent,
        MuiInputDirective,
        InputWrapComponent,
        ZippyModule,
        ExpandableComponent,
        InputWrapBodyDirective
    ]
})
export class BasketViewCouponFormComponent extends CouponFormComponentDef {
    readonly gtmService = inject(GtmService);
    readonly abService = inject(AbService);

    timeoutService = inject(TimeoutService);

    @Input()
    source?: string;

    private formErrorSend = false;

    @Input()
    override isCheckout? = false;

    override onSubmitSuccess() {
        super.onSubmitSuccess();
        this.gtmService.sendEventGA4('ab_test_tracking_promo_code', {
            variant: !this.isCheckout ? this.app.ab.getVariant('basketPromoCode') : this.app.ab.getVariant('checkoutPromoCode')
        });
    }
    get showExpandableForm(): boolean {
        if (this.isCheckout && this.abService.getVariant('checkoutPromoCode') !== 'B') {
            return true;
        } else if (!this.isCheckout && this.abService.getVariant('basketPromoCode') !== 'B') {
            return true;
        } else {
            return false;
        }
    }

    override submit(): void {
        super.submit(undefined, this.onError);
        if (this.form.invalid && !this.formErrorSend) {
            this.onError({ error: GTM_FORM_FIELD_ERROR_MESSAGE });
            this.formErrorSend = true;
        }
    }

    private onError = (e?: { error: string }): void => {
        e &&
            (this.gtmService as LocalGtmService).sendFormError(
                e.error,
                this.source || 'Basket Coupon',
                this.source?.toLowerCase()?.includes('payment') ? 3 : undefined,
                this.data.coupon
            );
    };
}
